import { CSRProxyForm } from 'templates';
import { memo } from 'react';

const CSRProxy = () => {

  return (
    <>
      <div>
        <div id="main-content" className="container-lg px-0">
          <CSRProxyForm />
        </div>
      </div>
    </>
  );
};

export default memo(CSRProxy);